import React from "react";
import PageTitle from "@cs/components/src/PageTitle";
import Table from "@cs/components/src/Table";
import Section from "@cs/components/src/Section";
import Spinner from "@cs/components/src/Spinner";
import { useQuery } from "react-query";
import ApiService from "../../services/ApiService";
import { PageWrapper } from "@cs/components/src/PageWrapper";

interface RowProps {
  organization: Billing;
}

interface Billing {
  systemDomainId: string;
  title: string;
  balance: string;
}

const OrganizationBillingRow = (props: RowProps) => {
  const { organization } = props;
  return (
    <>
      <span>{organization.title}</span>
      <span>{organization.balance}</span>
    </>
  );
};
const BillingListScreen = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["billingList"],
    queryFn: async () => {
      const response = await ApiService.fetch<{ data: Billing[] }>(
        "GET",
        `/api/config/organization/billing`
      );
      return response.data;
    },
  });

  return (
    <div>
      <PageTitle
        title="Billing"
        error={isError ? "Problem loading billing" : undefined}
      ></PageTitle>

      {isLoading ? (
        <Spinner />
      ) : (
        !isError && (
          <PageWrapper>
            <Section>
              <Table
                columns={[
                  { title: "Name", width: "300px" },
                  { title: "Balance", width: "1fr" },
                ]}
                columnGrid
                rows={
                  data?.map((organization) => ({
                    id: organization.systemDomainId,
                    element: () => (
                      <OrganizationBillingRow organization={organization} />
                    ),
                  })) ?? []
                }
                autoHeight={{}}
                rowHeight={40}
              />
            </Section>
          </PageWrapper>
        )
      )}
    </div>
  );
};

export default BillingListScreen;
